<template>
  <div class="wrapper">
    <!-- 标题区域 -->
    <div class="page-header">
      <div class="header-content">
        <h2 class="page-title">
          <i class="el-icon-s-custom title-icon"></i>
          {{ $route.meta.name }}
        </h2>
        <div class="header-stats">
          <div class="stat-item">
            <span class="stat-label">总记录数</span>
            <span class="stat-value">{{ total }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-search"></i>
        <span>筛选条件</span>
      </div>
      <div class="header-search">
        <el-form ref="form" inline :model="searchData" label-width="100px">
          <el-form-item label="商户名称">
            <el-input 
              v-model="searchData.merchantName" 
              size="small" 
              placeholder="请输入商户名称"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人手机号">
            <el-input 
              v-model="searchData.legalMobile" 
              size="small" 
              placeholder="请输入法人手机号"
              style="width: 220px"
            ></el-input>
          </el-form-item>
          <el-form-item label=" " label-width="50px">
            <el-button 
              type="primary" 
              size="small" 
              icon="el-icon-search" 
              @click="getList()"
              class="search-btn"
            >
              搜索
            </el-button>
            <el-button 
              type="info" 
              size="small" 
              icon="el-icon-refresh" 
              @click="reset"
              class="reset-btn"
            >
              重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card" shadow="never">
      <div class="card-header-title">
        <i class="el-icon-s-grid"></i>
        <span>商户列表</span>
        <div class="header-actions">
          <el-button
            v-checkbtn="isShowBtn(AUTH_BTN.merchant_list_add)"
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="showAddOrEdit = true; rowId = null;"
            class="add-btn"
            >新增</el-button
          >
        </div>
      </div>
      
      <tp-table
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize"
      />
    </el-card>

    <!-- 新增&编辑 -->
    <AddOrEdit
        v-if="showAddOrEdit"
        :rowId="rowId"
        :showAddOrEdit="showAddOrEdit"
        @closeDialog="closeDialogFun"
    />
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getListAPI, changeStatusAPI, deleteMerchantAPI } from './api';
import AddOrEdit from "./add-edit.vue";

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p class="table-cell-text">{row['id'] || '-'}</p>
    }
  },
  {
    label: '商户名称',
    prop: 'merchantName',
    minWidth: '150',
    customRender(h, row) {
      return <p class="table-cell-text">{row['merchantName'] || '-'}</p>
    }
  },
  {
    label: '企业名称',
    prop: 'companyName',
    minWidth: '150',
    customRender(h, row) {
      return <p class="table-cell-text">{row['companyName'] || '-'}</p>
    }
  },
  {
    label: '法人姓名',
    prop: 'legalName',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text">{row['legalName'] || '-'}</p>
    }
  },
  {
    label: '手机号',
    prop: 'legalMobile',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text">{row['legalMobile'] || '-'}</p>
    }
  },
  {
    label: '分配比例',
    prop: 'allocateRate',
    minWidth: '120',
    customRender(h, row) {
      return <p class="table-cell-text amount-value">{row['allocateRate'] ? `${row['allocateRate']}%` : '-'}</p>
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '120',
    customRender(h, row) {
      return (
        <div>
          <el-switch
            disabled={!this.isShowBtn(this.AUTH_BTN.merchant_list_status)}
            class="switch"
            onChange={() => this.changeStatus(row)}
            v-model={row['status']}
            active-value={true}
            inactive-value={false}
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </div>
      )
    }
  },
  {
    label: '操作',
    width: '180',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div class="action-links">
          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.merchant_list_edit) || row['status']}
            underline={false}
            type="primary"
            onClick={() => {
              this.showAddOrEdit = true;
              this.rowId = row['id'];
            }}
            class="action-link"
          >
            编辑
          </el-link>

          <el-link
            disabled={!this.isShowBtn(this.AUTH_BTN.merchant_list_del) || row['status']}
            underline={false}
            type="primary"
            onClick={() => this.handleDel(row)}
            class="action-link"
          >
            删除
          </el-link>
        </div>
      )
    }
  }
];

export default {
  name: 'MerchantList',
  components: {AddOrEdit},
  mixins: [authBtnMixin],
  data() {
    return {
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      formPwd: {},
      searchData: {
        merchantName: '',
        legalMobile: ''
      },
      rowId: null,
      showAddOrEdit: false,
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getList()
    },
    pageSize() {
      this.getList()
    }
  },
  mounted() {
    this.getList()
  },

  methods: {
    async getList() {
      const { merchantName, legalMobile } = this.searchData
      let params = { merchantName, legalMobile, pageSize: this.pageSize, page: this.currentPage }
      const res = await getListAPI(params)
      this.list = res.list || []
      this.total = res.total || 0
    },
    // 删除
    handleDel({ id }) {
      this.$confirm('此操作将永久删除该商户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteMerchantAPI(id).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
    // 启用/禁用
    changeStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let statusDesc = !status ? '禁用' : '启用';
      this.$confirm(`此操作将该商户${statusDesc}吗, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = status;
          changeStatusAPI(data).then(() => {
            this.getList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          row.status = !status;
          this.$message({ type: 'info', message: '已取消操作' });
        })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    },
    // 关闭弹框
    closeDialogFun(flag) {
      this.showAddOrEdit = false;
      if (flag) {
        this.getList();
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  background: linear-gradient(180deg, #f0f2f5 0%, #fafbfc 50%, #ffffff 100%);
  padding: 20px;
  min-height: calc(100vh - 84px);
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 200px;
    background: linear-gradient(135deg, rgba(64, 158, 255, 0.05) 0%, rgba(102, 177, 255, 0.02) 100%);
    pointer-events: none;
    z-index: 0;
  }
}

// 页面标题区域
.page-header {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
    border-radius: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
  }
  
  .page-title {
    margin: 0;
    font-size: 24px;
    font-weight: 700;
    color: #1a1e25;
    display: flex;
    align-items: center;
    gap: 12px;
    letter-spacing: -0.5px;
    
    .title-icon {
      font-size: 28px;
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
  }
  
  .header-stats {
    display: flex;
    gap: 24px;
    
    .stat-item {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 8px 16px;
      background: linear-gradient(135deg, #f0f7ff 0%, #e6f2ff 100%);
      border-radius: 10px;
      border: 1px solid rgba(64, 158, 255, 0.15);
      
      .stat-label {
        font-size: 12px;
        color: #909399;
        margin-bottom: 4px;
      }
      
      .stat-value {
        font-size: 20px;
        font-weight: 700;
        color: #409EFF;
        line-height: 1;
      }
    }
  }
}

// 卡片标题样式
.card-header-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f2f5;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
  
  .header-actions {
    display: flex;
    gap: 12px;
    margin-left: auto;
    
    .add-btn {
      border-radius: 10px;
      padding: 9px 20px;
      font-weight: 600;
      font-size: 13px;
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      
      &:hover:not(.is-disabled) {
        transform: translateY(-2px);
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
      }
      
      &.is-disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }
}

// 搜索卡片样式
.search-card {
  margin-bottom: 20px;
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #409EFF 0%, #66b1ff 50%, #85c1ff 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px 28px;
  }

  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 15px;
        margin-bottom: 10px;
        
        .el-form-item__label {
          color: #303133;
          font-weight: 600;
          letter-spacing: 0.3px;
          font-size: 14px;
          position: relative;
          
          &::after {
            content: ':';
            margin-left: 2px;
            color: #909399;
          }
        }
        
        .el-input {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          
          .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #fafbfc;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
              background: #ffffff;
            }
          }
          
          &.is-active .el-input__inner,
          .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
            background: #ffffff;
          }
        }
      }
      
      .search-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
        border: none;
        box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
          box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }

      .reset-btn {
        border-radius: 10px;
        padding: 10px 24px;
        font-weight: 600;
        font-size: 13px;
        background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(144, 147, 153, 0.25);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        letter-spacing: 0.3px;

        &:hover {
          background: linear-gradient(135deg, #909399 0%, #82848a 100%);
          box-shadow: 0 6px 16px rgba(144, 147, 153, 0.35);
          transform: translateY(-2px);
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
        }
      }
    }
  }
}

// 表格卡片样式
.table-card {
  border-radius: 16px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.04);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: 1;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #67C23A 0%, #85ce61 50%, #95d475 100%);
  }

  &:hover {
    box-shadow: 0 8px 28px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
    transform: translateY(-2px);
  }

  ::v-deep .el-card__body {
    padding: 24px;
  }

  ::v-deep .tp-table {
    .el-table {
      border-radius: 12px;
      overflow: hidden;
      border: 1px solid #EBEEF5;
      background: #ffffff;

      th {
        background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
        color: #303133;
        font-weight: 700;
        padding: 18px 0;
        border-bottom: 2px solid #E4E7ED;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        font-size: 12px;
        
        &:first-child {
          padding-left: 20px;
        }
      }

      tbody {
        tr {
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          border-bottom: 1px solid #F0F2F5;

          &:hover > td {
            background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
          }
          
          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 18px 0;
            border-bottom: 1px solid #F5F7FA;
            
            &:first-child {
              padding-left: 20px;
            }
            
            .table-cell-text {
              margin: 0;
              color: #606266;
              font-size: 13px;
              line-height: 1.8;
              font-weight: 400;
            }
            
            .amount-value {
              color: #303133;
              font-weight: 600;
              font-size: 14px;
            }
            
            .action-links {
              display: flex;
              flex-wrap: wrap;
              gap: 8px;
              
              .action-link {
                font-weight: 500;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                
                &:hover:not(.is-disabled) {
                  transform: translateY(-1px);
                  color: #66b1ff;
                }
                
                &.is-disabled {
                  opacity: 0.5;
                  cursor: not-allowed;
                }
              }
            }
          }
        }
      }
    }

    .pagination {
      margin-top: 24px;
      padding: 20px 0 0;
      border-top: 2px solid #F0F2F5;
      
      ::v-deep .el-pagination {
        .el-pagination__total {
          color: #606266;
          font-weight: 500;
        }
        
        .btn-prev,
        .btn-next {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            background: #F5F7FA;
            color: #409EFF;
          }
        }
        
        .el-pager li {
          border-radius: 6px;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            background: #F5F7FA;
          }
          
          &.active {
            background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
            color: #ffffff;
            font-weight: 600;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
          }
        }
        
        .el-select .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        .el-input__inner {
          border-radius: 6px;
          border-color: #DCDFE6;
          
          &:hover {
            border-color: #C0C4CC;
          }
          
          &:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
          }
        }
      }
    }
  }
}

// switch按钮样式
::v-deep .switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }

  .el-switch__label--right {
    z-index: 1;
  }

  .el-switch__label--right span {
    margin-left: 5px;
    margin-right: 10px;
  }

  .el-switch__label--left {
    z-index: 1;
  }

  .el-switch__label--left span {
    margin-left: 20px;
  }

  .el-switch__label.is-active {
    display: block;
  }

  .el-switch__core,
  .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .search-card .header-search .el-form ::v-deep {
    .el-form-item {
      margin-right: 12px;
    }
  }
  
  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    
    .header-stats {
      width: 100%;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 768px) {
  .wrapper {
    padding: 12px;
  }
  
  .page-header .header-content {
    padding: 16px;
    
    .page-title {
      font-size: 20px;
    }
  }
  
  .search-card,
  .table-card {
    border-radius: 12px;
    
    ::v-deep .el-card__body {
      padding: 16px;
    }
  }
  
  .card-header-title {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    
    .header-actions {
      width: 100%;
      flex-wrap: wrap;
    }
  }
}
</style>
